import { render, staticRenderFns } from "./EditSubGroup.vue?vue&type=template&id=330932ac&scoped=true&"
import script from "./EditSubGroup.vue?vue&type=script&lang=ts&"
export * from "./EditSubGroup.vue?vue&type=script&lang=ts&"
import style0 from "./EditSubGroup.vue?vue&type=style&index=0&id=330932ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330932ac",
  null
  
)

export default component.exports